import StatusBadge from "../../../../../utils/StatusBadge";

export const officeColumns = [
    { key: "__sn", label: "#", },
    { key: "name", label: "Office", sortable: true, },
    { key: "code", label: "Branch Code", sortable: true, },
    { key: "city", label: "City", sortable: true, },
    { key: "manager", label: "Office Head", sortable: true, },
    { key: "departments", label: "Departments", sortable: true, },
    { key: "employees", label: "Employees", sortable: true, },
    { key: "capacity", label: "Capacity", sortable: true, },
    {
        key: "productivity", label: "Productivity", sortable: true,
        render: (value) => `${value}%`,
    },
    {
        key: "status", label: "Status", sortable: true,
        render: (value) => ( <StatusBadge status={value} /> ),
    },
];

export const officeData = [
    {
        id: 1,
        name: "Head Office",
        code: "AHM-001",
        city: "Ahmedabad",
        manager: "Rahul Patel",
        departments: 6,
        employees: 58,
        capacity: 70,
        productivity: 94,
        status: "Active",
    },

    {
        id: 2,
        name: "Surat Branch",
        code: "SUR-001",
        city: "Surat",
        manager: "Amit Shah",
        departments: 4,
        employees: 34,
        capacity: 40,
        productivity: 91,
        status: "Active",
    },

    {
        id: 3,
        name: "Mumbai Branch",
        code: "MUM-001",
        city: "Mumbai",
        manager: "Neha Mehta",
        departments: 3,
        employees: 27,
        capacity: 35,
        productivity: 89,
        status: "Active",
    },

    {
        id: 4,
        name: "Vadodara Branch",
        code: "VAD-001",
        city: "Vadodara",
        manager: "Jay Desai",
        departments: 2,
        employees: 16,
        capacity: 25,
        productivity: 82,
        status: "Inactive",
    },

    {
        id: 5,
        name: "Rajkot Branch",
        code: "RAJ-001",
        city: "Rajkot",
        manager: "Priya Shah",
        departments: 2,
        employees: 12,
        capacity: 20,
        productivity: 86,
        status: "Active",
    },
];
